import { idToken, memberIdSelector } from '../selectors/sessionSelector';
import { ReduxStore } from '../interfaces/store';
import { sendViewAuction } from '~/helpers/orchestration/notifications';
import { ReduxDispatch } from '../interfaces/Redux';
import { getAuction as getAuctionCall } from '~/helpers/orchestration/auctions';
import Auction, { AuctionNotFound } from '../interfaces/Auction';
import { log } from '~/helpers/bugsnagHelper';
import { failedToFetch } from './connection-events';

export const VIEW_AUCTION_REQUEST = 'VIEW_AUCTION_REQUEST';
export const VIEW_AUCTION_SUCCESS = 'VIEW_AUCTION_SUCCESS';
export const VIEW_AUCTION_FAILURE = 'VIEW_AUCTION_FAILURE';
export const viewAuction =
  (auctionId: string) =>
  (dispatch: ReduxDispatch, getState: () => ReduxStore) => {
    const state = getState();
    const storeToken = idToken(state);

    dispatch({ type: VIEW_AUCTION_REQUEST });

    if (!storeToken) {
      return;
    }

    return sendViewAuction({ idToken: storeToken, auctionId })
      .then(() => {
        dispatch({ type: VIEW_AUCTION_SUCCESS, payload: auctionId });
      })
      .catch((err: unknown) => {
        dispatch({ type: VIEW_AUCTION_FAILURE, payload: err });
      });
  };

export const getAuctionRequest = () => ({
  type: 'GET_AUCTION_REQUEST' as const
});

export const getAuctionSuccess = (payload: Auction | AuctionNotFound) => ({
  type: 'GET_AUCTION_SUCCESS' as const,
  payload
});

export const getAuctionFailure = (payload: string) => ({
  type: 'GET_AUCTION_FAILURE' as const,
  payload
});

export type AuctionRequestsType =
  | ReturnType<typeof getAuctionRequest>
  | ReturnType<typeof getAuctionSuccess>
  | ReturnType<typeof getAuctionFailure>;

export const getAuction =
  (auctionId: string) =>
  async (dispatch: ReduxDispatch, getState: () => ReduxStore) => {
    const state = getState();
    const memberId = memberIdSelector(state);

    dispatch(getAuctionRequest());

    const params = {
      id: auctionId,
      params: {
        memberId
      }
    };

    try {
      const auction = await getAuctionCall(params);

      if (auction) {
        return dispatch(getAuctionSuccess(auction));
      } else {
        dispatch(failedToFetch());
        return dispatch(getAuctionFailure(auctionId));
      }
    } catch (error: unknown) {
      log(new Error(`Failed to fetch auction with id: ${auctionId}`), {
        severity: 'warning',
        error
      });
      dispatch(failedToFetch());
      return dispatch(getAuctionFailure(auctionId));
    }
  };
